import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
// import AdminReducer from "../features/slices/admin/";
import UserReducer from "../features/slices/user/UserSlice";

const persistConfig = {
  key: "root",
  storage,
};
const rootReducer = combineReducers({
  user: UserReducer,
  // admin: AdminReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
 
  reducer: persistedReducer,
});
export const persistor = persistStore(store);
